export const stringToDate = (date: string | null | undefined): string => {
  if (date) {
    return date.replace('T', ' ').split(' ', 1).join(':')
  }
  return '-'
}
